import React from "react";
import { useTranslate } from "@refinedev/core";

import { Modal } from "@shared/components";
import { ConfigForm } from "../ConfigForm";
import { EditConfigModalProps } from "./types";
import { useEditConfigModal } from "./controller";

export const EditConfigModal = React.memo(
  ({ modalRef, integrations, onComplete }: EditConfigModalProps) => {
    const translate = useTranslate();
    const { methods, handleSubmit, isPending } = useEditConfigModal(
      modalRef,
      integrations,
      onComplete
    );

    return (
      <Modal
        ref={modalRef}
        title={translate("v1/agreement_integration_config_admin.titles.edit")}
        onConfirm={handleSubmit}
        methods={methods}
        isPending={isPending}
      >
        <ConfigForm integrations={integrations} lockPair mode="edit" />
      </Modal>
    );
  }
);
